// Visual source of truth: docs/specs/2026-09-30-kick-logo.md.
// Sizes are Figma geometry with no token family, so they live in a
// component-scoped custom property. Paths carry no `fill` attribute, so the
// icon-color recipes never reach them.

@layer base-components {
    .kickLogo {
        // Override hatch (spec K7): set these via className.
        --kick-logo-size: 48px;
        --kick-logo-tile: var(--fg-primary);
        --kick-logo-mark: var(--fg-on-solid);

        display: block;
        flex-shrink: 0;
        width: var(--kick-logo-size);
        height: var(--kick-logo-size);

        &[data-variant="full"] {
            width: calc(var(--kick-logo-size) * 150 / 48);
        }

        &[data-color="white"] {
            --kick-logo-tile: var(--fg-on-solid);
            --kick-logo-mark: var(--fg-primary);
        }

        &[data-size="xs"] {
            --kick-logo-size: 16px;
        }

        &[data-size="sm"] {
            --kick-logo-size: 20px;
        }

        &[data-size="md"] {
            --kick-logo-size: 24px;
        }

        &[data-size="lg"] {
            --kick-logo-size: 32px;
        }

        &[data-size="xl"] {
            --kick-logo-size: 40px;
        }

        &[data-size="2xl"] {
            --kick-logo-size: 48px;
        }
    }

    .tile,
    .wordmark {
        fill: var(--kick-logo-tile);
    }

    .mark {
        fill: var(--kick-logo-mark);
    }

    .cutout {
        fill-rule: evenodd;
    }
}
